/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import Menu from './Menu';

import styles from '../../../styles/menus/sections-menu.module.scss';

const propTypes = {
    className: PropTypes.string,
    items: AppPropTypes.menuItems,
};

const defaultProps = {
    className: null,
    items: [],
};

const SectionsMenu = ({ className, items }) => (
    <nav
        className={classNames(styles.container, {
            [className]: className !== null,
        })}
    >
        <Menu
            items={items}
            className={styles.menu}
            itemsClassName={styles.items}
            itemClassName={styles.item}
            linkClassName={styles.link}
            activeItemClassName={styles.activeItem}
        />
    </nav>
);

SectionsMenu.propTypes = propTypes;
SectionsMenu.defaultProps = defaultProps;

export default SectionsMenu;
